import { useEffect } from "react";

import {
  createManifestBlobURL,
  updateManifestLink,
  updatePWAIconsOnly,
} from "@vega-core/utils/dynamicManifest";
import { isGPPortal } from "@vega-core/utils/global";

import { usePublicConfig } from "./usePublicConfig";

export function useDynamicManifest(): void {
  const config = usePublicConfig();

  useEffect(() => {
    const portalType = isGPPortal ? "gp" : "lp";

    updatePWAIconsOnly(config);

    const manifestURL = createManifestBlobURL({
      portalType,
      companyConfig: config,
    });

    updateManifestLink(manifestURL);

    return () => {
      URL.revokeObjectURL(manifestURL);
    };
  }, [config]);
}
